/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Board_Write_HintInputs */

const en_us2_board_write_hint = /** @type {(inputs: Board_Write_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No names, contacts or anyone's health details. The team reads it before publishing.`)
};

const pt_br2_board_write_hint = /** @type {(inputs: Board_Write_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sem nomes, contatos ou dados de saúde de ninguém. A equipe lê antes de publicar.`)
};

const pt_pt2_board_write_hint = /** @type {(inputs: Board_Write_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sem nomes, contatos ou dados de saúde de ninguém. A equipe lê antes de publicar.`)
};

/** @type {(inputs: Board_Write_HintInputs) => LocalizedString} */
const es_419_board_write_hint = en_us2_board_write_hint;

/** @type {(inputs: Board_Write_HintInputs) => LocalizedString} */
const fr_fr2_board_write_hint = en_us2_board_write_hint;

/** @type {(inputs: Board_Write_HintInputs) => LocalizedString} */
const de_de2_board_write_hint = en_us2_board_write_hint;

/** @type {(inputs: Board_Write_HintInputs) => LocalizedString} */
const it_it2_board_write_hint = en_us2_board_write_hint;

/**
* | output |
* | --- |
* | "No names, contacts or anyone's health details. The team reads it before publishing." |
*
* @param {Board_Write_HintInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const board_write_hint = /** @type {((inputs?: Board_Write_HintInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Board_Write_HintInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_board_write_hint(inputs)
	if (locale === "es-419") return es_419_board_write_hint(inputs)
	if (locale === "pt-PT") return pt_pt2_board_write_hint(inputs)
	if (locale === "fr-FR") return fr_fr2_board_write_hint(inputs)
	if (locale === "de-DE") return de_de2_board_write_hint(inputs)
	if (locale === "it-IT") return it_it2_board_write_hint(inputs)
	return en_us2_board_write_hint(inputs)
});
export { board_write_hint as "board.write_hint" }